import * as Routes from 'constants/Routes'
import { logout } from 'common/actions/auth'

export default store => ({
  path: Routes.LOGOUT,
  onEnter: () => {
    store.dispatch(logout())
  }
})
